import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Row, Col, Form, Label, Card, CardBody } from 'reactstrap';
import { useLocation } from 'react-router-dom';
import CustomToast from '../../utils/CustomToast';

const Trophy = ({ draftStatus, onNextPage, onData, data, onPrevPage, onDraftSubmit, userRole, submitFormStatus, onSubmit }) => {
    const { register, setValue, getValues, handleSubmit, formState: { errors }, reset } = useForm();

    const location = useLocation();
    var currentPathName = location.pathname;

    const togglePrevPage = () => {
        onPrevPage();
        onData({ trophy_data: getValues() });
    }

    const saveDraftSubmit = () => {
        onDraftSubmit(getValues());
    };

    const nextPage = (e) => {
        onNextPage();
        onData({ trophy_data: e });
    };

    const submit = () => {  
        const trophy_first_name = getValues('trophy_first_name');
        const trophy_last_name = getValues('trophy_last_name');
        const trophy_job_position = getValues('trophy_job_position');
        
        if (!trophy_first_name) {
            CustomToast.warning('First name is required!');
            return;
        } else if (!trophy_last_name) {
            CustomToast.warning('Last name is required!');
            return;
        } else if (!trophy_job_position) {
            CustomToast.warning('Job position is required!');
            return;
        }

        onData({ trophy_data: getValues() });
        onSubmit(getValues());
    };

    useEffect(() => {
        if (data) {
            const trophyFields = [
                'trophy_first_name',
                'trophy_last_name',
                'trophy_job_position',
                'trophy_organization_name',
                'trophy_organization_email',
                'trophy_organization_phone',
            ];
    
            trophyFields.forEach(field => setValue(field, data[field]));
        }
    }, [data, setValue]);

    return (
        <Col lg="12" className="px-0">
            <Form onSubmit={handleSubmit(nextPage)}>
                <Card className="mb-3">
                    <CardBody>
                        <Label
                            for="trophy"
                            className="award-subheader"
                        >
                            <p className="mb-3">
                                This is the form confirming who your
                                representative will be at the Awards in
                                the event you should win, i.e., who will
                                be your trophy recipient.
                            </p>

                            <p className="font-weight-bold">
                                IMPORTANT INFORMATION
                            </p>

                            <p className="small">
                                1. It is important that you advise us
                                immediately if any details change.
                            </p>
                            <p className="small">
                                2. Please ensure all details are entered
                                accurately.
                            </p>
                            <p className="small">
                                3. Please state name as is most commonly
                                used, i.e. Christopher or Chris, Jennifer
                                or Jen etc.
                            </p>
                        </Label>

                        <Label className="award-subheader mb-2 font-weight-bold">
                            TROPHY RECIPIENT NAME <span className="asterisk_red">*</span>
                        </Label>
                        <Row>
                            <Col md="6" className="mb-0 pr-1">
                                <input
                                    {...register("trophy_first_name", 
                                        { required: "First Name is required" }
                                    )}
                                    type="text"
                                    maxLength={40}
                                    className={`form-control ${errors.trophy_first_name ? "form-invalid mb-0" : "mb-3"}`}
                                    placeholder="First Name"
                                />
                                {errors.trophy_first_name ? <p role="alert" className="invalid-feedback">{errors.trophy_first_name.message}</p> : null}
                            </Col>
                            <Col md="6" className="mb-0 pl-1">
                                <input
                                    {...register("trophy_last_name", 
                                        { required: "Last Name is required" }
                                    )}
                                    type="text"
                                    maxLength={40}
                                    className={`form-control ${errors.trophy_last_name ? "form-invalid mb-0" : "mb-3"}`}
                                    placeholder="Last Name"
                                />
                                {errors.trophy_last_name ? <p role="alert" className="invalid-feedback">{errors.trophy_last_name.message}</p> : null}
                            </Col>
                        </Row>

                        <Label className="award-subheader mb-2 font-weight-bold">
                            TROPHY RECIPIENT'S JOB POSITION <span className="asterisk_red">*</span>
                        </Label>
                        <input
                            {...register("trophy_job_position",
                                 { required: "Job Position is required" }
                            )}
                            type="text"
                            maxLength={100}
                            className={`form-control ${errors.trophy_job_position ? "form-invalid mb-0" : "mb-3"}`}
                        />
                        {errors.trophy_job_position ? <p role="alert" className="invalid-feedback">{errors.trophy_job_position.message}</p> : null}

                        <Label className="award-subheader mb-2 font-weight-bold">
                            TROPHY RECIPIENT'S ORGANISATION NAME
                        </Label>
                        <input
                            {...register("trophy_organization_name",
                                //  { required: "Organisation is required" }
                            )}
                            type="text"
                            maxLength={50}
                            className={`form-control ${errors.trophy_organization_name ? "form-invalid mb-0" : "mb-3"}`}
                        />
                        {errors.trophy_organization_name ? <p role="alert" className="invalid-feedback">{errors.trophy_organization_name.message}</p> : null}

                        <Row>
                            <Col lg="6" className="mb-0 pr-1">
                                <Label className="award-subheader mb-2 font-weight-bold">
                                    TROPHY RECIPIENT'S EMAIL
                                </Label>
                                <input
                                    {...register("trophy_organization_email",
                                        //  { required: "Email is required" }
                                    )}
                                    type="text"
                                    maxLength={80}
                                    className={`form-control ${errors.trophy_organization_email ? "form-invalid mb-0" : "mb-3"}`}
                                    placeholder="Trophy Recipient Email"
                                />
                                {errors.trophy_organization_email ? <p role="alert" className="invalid-feedback">{errors.trophy_organization_email.message}</p> : null}
                            </Col>
                            <Col lg="6" className="mb-0 pl-1">
                                <Label className="award-subheader mb-2 font-weight-bold">
                                    TROPHY RECIPIENT'S MOBILE NUMBER
                                </Label>
                                <input
                                    {...register("trophy_organization_phone",
                                        //  { required: "Mobile number is required" }
                                    )}
                                    type="text"
                                    maxLength={40}
                                    className={`form-control ${errors.trophy_organization_phone ? "form-invalid mb-0" : "mb-3"}`}
                                    placeholder="Trophy Recipient Phone"
                                />
                                {errors.trophy_organization_phone ? <p role="alert" className="invalid-feedback">{errors.trophy_organization_phone.message}</p> : null}
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                <Row>
                    <Col md="4" className="text-left">
                        <button
                            className="btn btn-outline-dark-prev"
                            onClick={togglePrevPage}
                            style={{ width: '130px', fontSize: '14px' }}
                            type='button'
                        >
                            <strong>PREVIOUS</strong>
                        </button>
                    </Col>
                    <Col md="8" className="text-right">
                        {currentPathName == "/entry-form/preview" ? 
                        //    <div className="bis-tooltip p-0" style={{ border: 'none', background: 'transparent' }}>
                        //         <button
                        //             className="btn btn-transparent text-dark"
                        //             style={{ width: '180px', fontSize: '14px' }}
                        //             type='button'
                        //             disabled
                        //         >
                        //             <strong>SAVE FOR LATER</strong>
                        //             <span className="bis-tooltiptext" style={{ width: '220px', marginLeft: '-107px' }}>This action is unavailable in this preview version</span>
                        //         </button>
                        //     </div>
                            null
                        : data.status == '' || data.status == 'Draft' ? (
                            <button
                                className="btn btn-transparent text-dark"
                                // onClick={saveDraftSubmit}
                                onClick={!draftStatus ? saveDraftSubmit : undefined}
                                style={{ width: '180px', fontSize: '14px' }}
                                type='button'
                                disabled={draftStatus}
                            >
                                <strong>{!draftStatus ? 'SAVE FOR LATER' : 'SAVING...'}</strong>
                            </button>
                        ) : null}
                        {userRole && userRole == 'Admin' && data.status != '' && data.status != 'Draft' ? (
                            <button
                                className="btn btn-blue-new"
                                type="button"
                                style={{ width: '130px', fontSize: '14px' }}
                                disabled={submitFormStatus}
                                onClick={submit}
                            >
                                <strong>SUBMIT</strong>
                            </button>
                        ) : (
                            <button
                                className="btn btn-blue-new"
                                type="submit"
                                style={{ width: '130px', fontSize: '14px' }}
                            >
                                <strong>NEXT PAGE</strong>
                            </button>
                        )}
                    </Col>
                </Row>
            </Form>
        </Col >
    );
};

export default Trophy;